module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container-fluid page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n                Quem somos ")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n                Conheça o Programa Parceiro Simonetti\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container page-content"
  }, [_c('div', {
    staticClass: "row pt-1 m-1"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 p-0 text-justify"
  }, [_c('img', {
    staticClass: "float-left mr-3",
    attrs: {
      "src": require("../assets/img/logo-h.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "1.5em",
      "font-weight": "300",
      "padding-top": "5px"
    }
  }, [_c('b', [_vm._v("\n                        Essa é uma modalidade de negócios da Móveis Simonetti, empresa sólida capixaba com cerca de\n                        trinta anos de história e mais de sessenta lojas no Brasil.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 p-0 pt-2 text-justify",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_c('p', [_vm._v("\n                    Hoje, a Móveis Simonetti é um sonho que se tornou realidade e atualmente é vista como um dos maiores\n                    nomes em bens duráveis do país. Surgiu então o desejo de expandir o seu negócio e alavancar novas\n                    parcerias com empreendedores o que originou o "), _c('b', [_vm._v("Programa Parceiro Simonetti")]), _vm._v("."), _c('br')]), _vm._v(" "), _c('p', [_vm._v("\n                    Todo o programa é destinado ao Empreendedor que almeja expandir seu mix de produtos, mas não\n                    consegue comprar direto com a indústria por motivo de baixo valor disponível para compra ou até mesmo\n                    por não necessitar montar grandes estoques."), _c('br')]), _vm._v(" "), _c('p', [_vm._v("\n                    Em nosso mix de produtos disponibilizamos móveis, eletrodomésticos, eletrônicos e aparelhos de\n                    telefonia, sem regras de quantidade mínima para aquisição."), _c('br')]), _vm._v(" "), _c('p', [_vm._v("\n                    A compra é realizada através do site, totalmente seguro, e a entrega é feita em até no máximo três dias\n                    ou se preferir, a mercadoria pode ser retirada em um dos nossos Centros de Distribuição.\n                    "), _c('br')]), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "color": "#c70000"
    }
  }, [_vm._v("Programa Parceiro Simonetti, é rápido, é fácil, é pra você!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c5b482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/src/pages/QuemSomos.vue
// module id = 876
// module chunks = 0